import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API } from "@/lib/api";

const SiteConfigContext = createContext(null);
const DEFAULTS = {
  brand_name: "InsureWell",
  logo_file_id: null,
  hero_eyebrow: "Trusted by 2,400+ families",
  hero_title_prefix: "Insurance built around",
  hero_title_highlight: "your life",
  hero_title_suffix: ", not the other way around.",
  hero_subtitle: "A modern application experience for health and life coverage.",
  cta_health_label: "Apply for Health",
  cta_life_label: "Apply for Life",
  hero_media_file_id: null,
  hero_media_type: "image",
  promo_enabled: false,
  promo_message: "",
  promo_url: "",
  why_eyebrow: "Why InsureWell",
  why_title: "A calmer way to apply.",
  why_box_1_title: "Encrypted at rest",
  why_box_1_desc: "Your medical and personal data is encrypted end-to-end and never sold.",
  why_box_2_title: "Document attachments",
  why_box_2_desc: "Upload IDs, prescriptions and existing policies in one place — PDFs and images supported.",
  why_box_3_title: "Real human agents",
  why_box_3_desc: "Every submission is reviewed by a licensed agent within 24 hours.",
  why_box_4_title: "Family-first plans",
  why_box_4_desc: "Add dependants and beneficiaries directly inside the application.",
  apply_base_url: "",
};

export function fileUrl(fileId) {
  if (!fileId) return null;
  return `${API}/files/${fileId}/download`;
}

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/site");
      setConfig({ ...DEFAULTS, ...data });
    } catch {
      setConfig(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteConfigContext.Provider value={{ config, refresh, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export const useSiteConfig = () => useContext(SiteConfigContext) || { config: DEFAULTS, refresh: () => {}, loading: false };
